import axiosInstance from "./axiosInstance";

// Auth And Users

export const LoginAdmin = async (payload) => {
  try {
    const response = await axiosInstance.post("/auths/login", payload);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetCurrentUser = async (id) => {
  try {
    const response = await axiosInstance.get(`/users/${id}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const ForgotPass = async (payload) => {
  try {
    const response = await axiosInstance.post("/auths/forgotPassword", payload);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const VerifyOTP = async (payload) => {
  try {
    const response = await axiosInstance.post("/auths/verify", payload);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const ResetPass = async (payload, id) => {
  try {
    const response = await axiosInstance.put(
      `/auths/resetPassword/${id}`,
      payload
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const UpdateProfile = async (payload, id) => {
  try {
    const response = await axiosInstance.put(`/users/${id}`, payload);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const ChangePass = async (payload, id) => {
  try {
    const response = await axiosInstance.put(
      `/auths/updatePassword/${id}`,
      payload
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Clients

export const GetClient = async (id) => {
  try {
    const response = await axiosInstance.get("/users/" + id);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetClients = async (params) => {
  try {
    const response = await axiosInstance.get(`/users?${params}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const UpdateClient = async (payload, id) => {
  try {
    const response = await axiosInstance.put(`/users/${id}`, payload);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const DeleteClient = async (payload, id) => {
  try {
    const response = await axiosInstance.put(`/users/${id}`, payload);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const BulkDeleteClient = async (payload) => {
  try {
    const response = await axiosInstance.post("/users/bulkDelete", payload);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Service Providers

export const GetServiceProviders = async (params) => {
  try {
    const response = await axiosInstance.get(`/businessProfiles?${params}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetServiceProviderById = async (id) => {
  try {
    const response = await axiosInstance.get(`/businessProfiles/${id}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const UpdateServiceProvider = async (payload, id) => {
  try {
    const response = await axiosInstance.put(
      `/businessProfiles/${id}`,
      payload
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const DeleteServiceProvider = async (payload, id) => {
  try {
    const response = await axiosInstance.put(
      `/businessProfiles/${id}`,
      payload
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetServiceProviderReviews = async (id, filters) => {
  try {
    let queryString = `businessProfileId=${id}`;
    const response = await axiosInstance.get(
      `/reviews?${queryString}&${filters}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetServiceProviderRating = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/reviews/providerTotalRating",
      payload
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetServiceProviderCategories = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/subCategories?businessProfileId=${id}&serverPaging=false`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetServiceProviderGallery = async (id, filters) => {
  try {
    let queryString = `businessProfileId=${id}`;
    const response = await axiosInstance.get(
      `/providerGalleries?${queryString}&${filters}&serverPaging=false`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const DeleteServiceProviderGallery = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `/providerGalleries/deletedProviderImage`,
      payload
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// export const UploadServiceProviderGallery = async (payload, onUploadProgress) => {
//     try {
//         const response = await axiosInstance.post('/images/upload', payload, { onUploadProgress: onUploadProgress });
//         return response.data;
//     } catch (error) {
//         return error.response;
//     }
// };

export const UpdateServiceProviderReviews = async (payload, id) => {
  try {
    const response = await axiosInstance.put(`/reviews/${id}`, payload);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetServiceProviderServiceList = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/providerServices/providersub/services?businessProfileId=${id}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const DeleteServiceProviderService = async (id) => {
  try {
    const response = await axiosInstance.delete(`/providerSubServices/${id}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetPrefrencesBySpId = async (id) => {
  try {
    const response = await axiosInstance.get(`/users/${id}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Refunds

export const GetRefundRequests = async (params) => {
  try {
    const response = await axiosInstance.get(`/refunds?${params}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const UpdateRefundRequest = async (payload, id) => {
  try {
    const response = await axiosInstance.put(`/refunds/${id}`, payload);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const CreateRefundRequest = async (payload) => {
  try {
    const response = await axiosInstance.post("/refunds", payload);
    return response.data;
  } catch (error) {
    return error.message;
  }
};

// Payouts

export const GetPayouts = async (params) => {
  try {
    const response = await axiosInstance.get(`/payoutRequests?${params}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const DownloadPayout = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/payoutRequests/pdf/download",
      payload,
      {
        responseType: "arraybuffer",
      }
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Reviews

export const GetAllReviews = async (filter) => {
  try {
    const response = await axiosInstance.get(`/reviews?${filter}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Dashboard

export const GetDashboardData = async (filter) => {
  try {
    const response = await axiosInstance.get(
      `/users/adminDashBoard/AllData?${filter}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetDashboardWidgetData = async (params) => {
  try {
    const response = await axiosInstance.get(
      `/dashboards/admin/count?${params}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetDashboardSigupChartData = async (params) => {
  try {
    const response = await axiosInstance.get(
      `/dashboards/admin/signUp/graph?${params}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetDashboardTotalRevenueChartData = async (params) => {
  try {
    const response = await axiosInstance.get(
      `/dashboards/admin/revenue/graph?${params}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetDashboardCommissionRevenueChartData = async (params) => {
  try {
    const response = await axiosInstance.get(
      `/dashboards/admin/commission/graph?${params}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetDashboardTotalCustomersChartData = async (params) => {
  try {
    const response = await axiosInstance.get(
      `/dashboards/admin/retention/graph?${params}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetDashboardServiceProviders = async () => {
  try {
    const response = await axiosInstance.get(
      `/dashboards/admin/sp/mostView/count`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetDashboardServiceCategoriesChartData = async () => {
  try {
    const response = await axiosInstance.get(
      `/dashboards/admin/category/graph`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetDashboardDeletedAccountsChartData = async (params) => {
  try {
    const response = await axiosInstance.get(
      `/dashboards/admin/deleted/graph?${params}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// SearchList

export const GetSearchList = async (filter) => {
  try {
    const response = await axiosInstance.get(`/searchLists?${filter}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};
export const DeleteSearchListItem = async (payload, id) => {
  try {
    const response = await axiosInstance.put(`/searchLists/${id}`, payload);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Support tickets

export const GetSupportTickets = async (params) => {
  try {
    const response = await axiosInstance.get(`/reportProblems?${params}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const UpdateSupportTicket = async (payload, ticketId) => {
  try {
    const response = await axiosInstance.put(
      `/reportProblems/${ticketId}`,
      payload
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Notifications

export const GetNotifications = async (params) => {
  try {
    const response = await axiosInstance.get(`/userNotifications?${params}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetNotificationsCount = async (params) => {
  try {
    const response = await axiosInstance.get(
      `/userNotifications/unRead/count?${params}`
    );
    return response?.data;
  } catch (error) {
    return error.response;
  }
};

export const SendNotification = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `/userNotifications/adminNotification`,
      payload
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const ClearNotifications = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `/userNotifications/clear/Notification/admin`,
      payload
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Templates

export const GetTemplates = async (params) => {
  try {
    const response = await axiosInstance.get(
      `/templates?${params}&serverPaging=false`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Get Clients

export const GetClientsList = async () => {
  try {
    const response = await axiosInstance.get(`/users/getAll/ClientList`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};
export const GetProvidersList = async () => {
  try {
    const response = await axiosInstance.get(`/users/getAll/ProviderList`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Mailing

export const SendEmail = async (payload) => {
  try {
    const response = await axiosInstance.post(`/users/userMail`, payload);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Promotions

export const GetPromotions = async (params) => {
  try {
    const response = await axiosInstance.get(`/promoCodes?${params}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetPromotionsBySpId = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/promoCodes?type=serviceProvider&userId=${id}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const AddPromotion = async (payload) => {
  try {
    const response = await axiosInstance.post("/promoCodes", payload);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const UpdatePromotion = async (payload, id) => {
  try {
    const response = await axiosInstance.put(`/promoCodes/${id}`, payload);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const DeletePromotion = async (id) => {
  try {
    const response = await axiosInstance.delete(`/promoCodes/${id}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Categories

export const GetCategories = async () => {
  try {
    const response = await axiosInstance.get("services/get/services");
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetAllCategories = async () => {
  try {
    const response = await axiosInstance.get("/Categories");
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Service Provider Dashboard Count
export const GetServiceProviderDashboardData = async ({
  startDate,
  endDate,
  userId,
  businessId,
}) => {
  try {
    const queryParams = new URLSearchParams();

    if (startDate) queryParams.append("startDate", startDate);
    if (endDate) queryParams.append("endDate", endDate);

    queryParams.append("userId", userId);
    queryParams.append("businessId", businessId);

    const response = await axiosInstance.get(
      `dashboards/sp/count?${queryParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Availiability

export const GetAvailability = async (id) => {
  try {
    const response = await axiosInstance.get(`days?userId=${id}`);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetServicesForAvailability = async (id) => {
  try {
    const response = await axiosInstance.get(
      `services/get/services?userId=${id}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetSlots = async (data) => {
  try {
    const response = await axiosInstance.get(
      `bookings/get/slots?serviceId=${data?.serviceId}&date=${data?.date}&currentTime=${data?.currentTime}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetBlockedDays = async (id) => {
  try {
    const response = await axiosInstance.get(
      `calendarDates?userId=${id}&serverPaging=false`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Toggle Availability
export const ToggleAvailability = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "providerAvailabilities/day/onOff",
      payload
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Appointments

export const GetAppointment = async (id) => {
  try {
    const response = await axiosInstance.get("/bookings/" + id);
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const GetAppointments = async (params) => {
  try {
    const response = await axiosInstance.get(`/bookings?${params}`);
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const GetAppointmentsBySpId = async (params) => {
  try {
    const response = await axiosInstance.get(`/bookings?${params}`);
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const GetAppointmentsByClientId = async (id) => {
  try {
    const response = await axiosInstance.get(`/bookings?clientId=${id}`);
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const UpdateAppointmentToCancelled = async (id, payload) => {
  try {
    const response = await axiosInstance.put(
      `/bookings/cancelled/${id}`,
      payload
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const UpdateAppointmentToFinished = async (id, payload) => {
  try {
    const response = await axiosInstance.put(
      `/bookings/finished/${id}`,
      payload
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const GetAppointmentReviews = async (bookingId) => {
  try {
    const response = await axiosInstance.get(`/reviews?bookingId=${bookingId}`);
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const GetAppointmentLogs = async (bookingId) => {
  try {
    const response = await axiosInstance.get(
      `/bookingLogs?bookingId=${bookingId}`
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};

// Transactions

export const GetTransactions = async (params) => {
  try {
    const response = await axiosInstance.get(`/transactionHistories?${params}`);
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const GetTransactionHistoryPdf = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/transactionHistories/pdf/download",
      payload,
      {
        responseType: "arraybuffer",
      }
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const GenerateTransactionHistoryData = async (params) => {
  try {
    const response = await axiosInstance.get(
      `/transactionHistories/generate/excel?startDate=${params?.startDate}&endDate=${params?.endDate}&paymentStatus=${params?.paymentStatus}&payType=${params?.payType}`,
      {
        responseType: "arraybuffer",
      }
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};

// Account Status

export const ChangeSpAccountStatus = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "spAccounts/check/status",
      payload
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const GetSpAccountStatus = async (params) => {
  try {
    const response = await axiosInstance.get(
      `spAccounts/stripe/account/status?userId=${params.userId}`
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};
// Images Upload

// export const UploadImage = async (payload) => {
//     try {
//         const response = await axiosInstance.post('/images/upload', payload);
//         return response.data;
//     } catch (error) {
//         return error.response;
//     }
// };

export const UploadImage = async (payload, onUploadProgress) => {
  try {
    const response = await axiosInstance.post("/images/upload", payload, {
      onUploadProgress: onUploadProgress,
    });
    return response.data;
  } catch (error) {
    return error.response;
  }
};
